import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const CPTCodes = withLazyFallback(
  () => import('components/admin/pages/Databank/CPTCodes/CPTCodes')
);
const CDTCodes = withLazyFallback(
  () => import('components/admin/pages/Databank/CDTCodes/CDTCodes')
);
const DatabankDashboard = withLazyFallback(
  () => import('components/admin/pages/Databank/Dashboard')
);
const EHRVendors = withLazyFallback(
  () => import('components/admin/pages/Databank/EHRVendors/EHRVendors')
);
const EmailTemplates = withLazyFallback(
  () => import('components/admin/pages/Databank/EmailTemplates/EmailTemplates')
);
const DatapointsTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Datapoints/DatapointsTable')
);
const GrowthDataTable = withLazyFallback(
  () => import('components/admin/pages/Databank/GrowthData/GrowthDataTable')
);
const ICD10Codes = withLazyFallback(
  () => import('components/admin/pages/Databank/ICD10Codes/ICD10Codes')
);
const Landmarks = withLazyFallback(
  () => import('components/admin/pages/Databank/Landmarks/Landmarks')
);
const ModifiersTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Modifiers/ModifiersTable')
);
const PayerPlansTable = withLazyFallback(
  () => import('components/admin/pages/Databank/PayerPlans/PayerPlansTable')
);
const OccupationsTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Occupations/OccupationsTable')
);
const SpecialtyTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Specialty/SpecialtyTable')
);

const ADMIN_DATABANK = [
  {
    path: 'databank',
    element: <DatabankDashboard />,
    handle: { title: 'Databank' },
    children: [
      { path: ':type', element: <DatapointsTable /> },
      { path: 'cpt-codes', element: <CPTCodes />, handle: { title: 'CPT® codes' } },
      { path: 'cdt-codes', element: <CDTCodes />, handle: { title: 'CDT codes' } },
      { path: 'icd10-codes', element: <ICD10Codes />, handle: { title: 'ICD-10 codes' } },
      { path: 'occupations', element: <OccupationsTable />, handle: { title: 'Occupations' } },
      { path: 'growth_data', element: <GrowthDataTable />, handle: { title: 'Growth data' } },
      { path: 'landmarks', element: <Landmarks />, handle: { title: 'Landmarks' } },
      { path: 'specialities', element: <SpecialtyTable />, handle: { title: 'Specialties' } },
      { path: 'modifiers', element: <ModifiersTable />, handle: { title: 'Modifiers' } },
      { path: 'payer-plans', element: <PayerPlansTable />, handle: { title: 'Payer plans' } },
      { path: 'ehr-vendors', element: <EHRVendors />, handle: { title: 'EHR vendors' } },
      {
        path: 'email-templates',
        element: <EmailTemplates />,
        handle: { title: 'Email templates' }
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_DATABANK;
